import { ImageModel, ModelEcr } from 'api/Exec/types';
import { modelsUrl } from 'app/consts/urls';
import { formatDateTime } from 'app/helpers/dateTime';

import { Typography } from 'antd';
import { ColumnsType } from 'antd/es/table';
import React from 'react';

export const useModelEcrsColumns = (onImageModelsClick: (imageModels: ImageModel[]) => void) => {
  const columns: ColumnsType<ModelEcr> = [
    {
      title: 'Image tag',
      dataIndex: 'imageTag',
      key: 'imageTag',
    },
    {
      title: 'Push date',
      key: 'imagePushedAt',
      render: (_, { imagePushedAt }) => <Typography.Text style={{ whiteSpace: 'nowrap' }}>{formatDateTime(imagePushedAt)}</Typography.Text>,
    },
    {
      title: 'Exist',
      key: 'gitCommit',
      render: (_, { imageModels }) => {
        return imageModels.length > 0 && (
          <Typography.Link onClick={() => onImageModelsClick(imageModels)} target="_blank">{`View ${imageModels.length}`}</Typography.Link>
        );
      },
    },
    {
      title: 'Digest',
      dataIndex: 'imageDigest',
      key: 'imageDigest',
    },
  ];

  return { columns };
};

export const useImageModelColumns = () => {
  const columns: ColumnsType<ImageModel> = [
    {
      title: 'Id',
      dataIndex: 'id',
      render: (_, { id }) => (
        <Typography.Link href={`${modelsUrl}/?model=${id}`} target="_blank">{id}</Typography.Link>
      ),
    },
    {
      title: 'Model API',
      dataIndex: 'modelApiName',
      key: 'modelApiName',
    },
  ];

  return { columns };
};
